import { ReadOnlyField } from "@dbn/omnichannel-design-system-g4p";
import { constant, pipe } from "fp-ts/function";
import { option } from "fp-ts";
import {
  DropdownField,
  DropdownFieldProps,
} from "../DropdownField/DropdownField";
import { ComponentProps } from "react";
import { ReadOnlyFieldToValue } from "../ReadOnlyField/ReadOnlyFieldToValue";

type Feedback = ComponentProps<typeof ReadOnlyField>["feedback"];

type Props<T> = DropdownFieldProps<T> & {
  edit: boolean;
  feedback?: Feedback;
  forceDrawerOnMobile?: boolean;
};

export function OptionalEditDropdownField<T>(props: Props<T>) {
  const { edit, forceDrawerOnMobile, ...fieldProps } = props;

  if (edit)
    return (
      <DropdownField
        {...fieldProps}
        forceDrawerOnMobile={forceDrawerOnMobile}
      />
    );

  const value = pipe(
    props.value,
    option.map(({ label }) => String(label)),
    option.getOrElse(constant(""))
  );

  return (
    <ReadOnlyFieldToValue
      size="medium"
      label={props.label}
      value={value}
      feedback={props.feedback}
    />
  );
}
